import { render, staticRenderFns } from "./AbacusRandom.vue?vue&type=template&id=204ec70a&scoped=true&"
import script from "./AbacusRandom.vue?vue&type=script&lang=js&"
export * from "./AbacusRandom.vue?vue&type=script&lang=js&"
import style0 from "./AbacusRandom.vue?vue&type=style&index=0&id=204ec70a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204ec70a",
  null
  
)

export default component.exports